import { useTranslation } from '@mint-lib/i18n';
import { Card, typographyVariants } from '@mint-lib/tw-components';

type Props = {
  description: string;
  descriptionList: string[];
};

const DescriptionCard = ({ description, descriptionList }: Props) => {
  const { t } = useTranslation('@myn/integrations_v2');

  if (description) {
    return (
      <div className="mt-6 max-w-[916px]">
        <Card className="w-full p-2">
          <div className="mb-4">
            <h4 className={typographyVariants({ variant: 'h4' })}>
              {t('Description')}
            </h4>
          </div>
          <div
            className="flex flex-col gap-4"
            style={{ wordBreak: 'break-word' }}
          >
            <p className={typographyVariants({ variant: 'bodyLong01' })}>
              {description}
            </p>
          </div>
        </Card>
      </div>
    );
  }

  if (descriptionList.length) {
    return (
      <div className="mt-6 max-w-[916px]">
        <Card className="w-full p-2">
          <div className="mb-4">
            <h4 className={typographyVariants({ variant: 'h4' })}>
              {t('Description')}
            </h4>
          </div>
          <div className="flex flex-col gap-4">
            {descriptionList.map((platformDescription: string) => (
              <p
                className={typographyVariants({ variant: 'bodyLong01' })}
                key={platformDescription}
              >
                {platformDescription}
              </p>
            ))}
          </div>
        </Card>
      </div>
    );
  }

  return null;
};

export default DescriptionCard;
